export const WIDTH_PDF_PORTRAIT = 757
export const PADDING_PDF = 50
export const WIDTH_PDF_PORTRAIT_WITHOUT_PADDING =
  WIDTH_PDF_PORTRAIT - 2 * PADDING_PDF
export const HEIGHT_PDF_PORTRAIT_WITHOUT_PADDING = 900
export const WIDTH_PDF_LANSCAPE = 1084
export const WIDTH_PDF_LANSCAPE_WITHOUT_PADDING =
  WIDTH_PDF_LANSCAPE - 2 * PADDING_PDF
export const HEIGHT_PDF_LANSCAPE_WITHOUT_PADDING = 580
export const MARGIN_TOP_TITLE_PANEL = 10
export const MARGIN_BOTTOM_TITLE_PANEL = 10
export const MARGIN_TOP_NOTE = 8

export const TYPE_ITEM_SETTING = {
  CHAPTER_HEADER: 'chapterHeader',
  PANEL: 'panel',
}

export const TYPE_ITEM_PDF = {
  CHAPTER_HEADER: 'chapterHeader',
  TITLE_PANEL: 'titlePanel',
  CONTENT_PANEL: 'contentPanel',
  NOTE: 'note',
}

export const TYPE_INFORMATION_PANEL = {
  NODE: 'node',
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
  SELECT: 'select',
}

export const VIEW_BY = {
  TREND: 'Trend',
  EACH_YEAR: 'Each year',
  TABLE: 'Table',
  CHART: 'Chart',
  MAP: 'Map',
}

export const MAIN_SCREEN = {
  COMPANY_ANALYSIS: 'companyAnalysis',
  PORTFOLIO_INSIGHT: 'portfolioInsight',
}

export const SCREEN = {
  [MAIN_SCREEN.COMPANY_ANALYSIS]: {
    COMPANY_PROFILE: 'companyProfile',
    FINANCIAL_STATEMENT: 'financialStatement',
    FINANCIAL_ANALYSIS: 'financialAnalysis',
    SCORE: 'score',
    OWNERSHIP_AND_GROUP: 'ownershipAndGroup',
    INDUSTRY_OVERVIEW: 'industryOverview',
    INDUSTRY_ANALYSIS: 'industryAnalysis',
    CORPORATE_RISK_SCORE: 'corporateRiskScore',
    CORPORATE_PERFORMANCE_SCORE: 'corporatePerformanceScore',
  },
  [MAIN_SCREEN.PORTFOLIO_INSIGHT]: {
    SUMMARY: 'summary',
    FINANCE: 'finance',
    SCORE: 'portfolioScore',
    SEGMENT: 'segment',
  },
}

export const TYPE_DOWNLOAD = {
  PREVIEW: 'preview',
  DOWNLOAD: 'download',
  PREVIEW_SINGLE_BOX: 'previewSingleBox',
}

export const DEFAULT_REPORT_TITLE = 'FiinGate Dynamic Report'

export const KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS = {
  SCORE_ANALYSIS: 'scoreAnalysis',
  TIME_PERIOD: 'TIME_PERIOD',
  TYPE_DISTRIBUTION: 'TYPE_DISTRIBUTION',
}

export const VALUE_SCORE_ANALYSIS = {
  SCORE_BAR: 1,
  TREND_OF_SCORE: 2,
  YEARLY: 'Yearly',
  QUARTERLY: 'Quarterly',
  MONTHLY: 'Monthly',
  COMPANY: 'data1',
  INDUSTRY: 'data2',
  REGION: 'data3',
  YEAR: 'data4',
  DISTRIBUTION_CHART: 7,
  BY_INDUSTRY: 'industry',
  BY_REGION: 'region',
  BY_YEAR: 'year',
}

export const KEY_DYNAMIC_CORPORATE_PERFORMANCE_SCORE = {
  SCORE_COMPANY_PERFORMANCE: 'SCORE_COMPANY_PERFORMANCE',
  VIEW_BY: 'VIEW_BY',
  TIME_PERIOD: 'TIME_PERIOD',
}

export const VALUE_CORPORATE_PERFORMANCE_SCORE = {
  TABLE: 'Table',
  CHART: 'Chart',
  SCORE: 1,
  HISTORICAL_CHANGE: 2,
  YEARLY: 'Yearly',
  QUARTERLY: 'Quarterly',
  MONTHLY: 'Monthly',
  PROBABILITY_OF_DEFAULT: 'pd',
  SCORE_COMPANY: 'scoreCompany',
  SCORE_MODEL_SCORE: 'scoreModelScore',
}

export const MARGIN_LEFT_CHART_DYNAMIC = 16

export const IGNORE_QUERY = 'isSearch'
